export function Logo({ className = "" }) {
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="flex-shrink-0"
      >
        <path
          d="M12 12L24 12L24 0Z"
          fill="white"
        />
      </svg>
      <span className="font-heading text-lg sm:text-xl tracking-tight">PitchMetric</span>
    </div>
  )
}

